var path = 'areas/accounts/views/account_summary.html';
var html = "<div> <h4><a href=#/accounts/{{account.Id}}>{{ account.Name }}</a></h4> <div class=smaller-fonts ng-show=account.environments>Only in: <environment-list tags=account.environments></environment-list></div> <applied-tags-list octo-feature=IsMultiTenancyEnabled ng-model=account.TenantTags style=margin:0></applied-tags-list> <markdown class=subtle text=\"account.Description || '_No description provided_'\"></markdown> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/accounts/views/account_summary.html
// module id = 2456256986122049
// module chunks = 1